import { useState } from "react";
import { useApiService } from "../../../server/api/client";
import { EmailContentService } from "../client";
import type { UnlayerAccount } from "../types/unlayer-account";

export const useUnlayerAccount = (): UnlayerAccount | undefined => {
  const [unlayerAccount, setUnlayerAccount] = useState<UnlayerAccount>();

  useApiService(
    EmailContentService,
    async ({ apiService }) => setUnlayerAccount((await apiService.account()).data),
    [],
  );

  return unlayerAccount;
};
